/**
 * A member's name as a cell/heading text (DNKADM-0454 V-68/V-69). A missing name reads
 * "Unnamed member" and the contact id rides ONLY in a tooltip, never as the visible text:
 * an operator is never shown a bare identifier as a person (`personLabel`'s rule).
 */
import { Tooltip } from '@mui/material';
import { UNNAMED_MEMBER, nonEmpty } from '@/utils/personLabel';

export function MemberNameText({
  name,
  contactId,
}: {
  name: string | null | undefined;
  contactId: string | null | undefined;
}) {
  const known = nonEmpty(name);
  // Marked private so "Ask about this" (DNKADM-0463) never reads a member's name.
  if (known !== null) return <span data-ask-dink-private>{known}</span>;
  const id = nonEmpty(contactId);
  if (id === null) return <span data-ask-dink-private>{UNNAMED_MEMBER}</span>;
  return (
    <Tooltip title={id} describeChild>
      <span data-ask-dink-private>{UNNAMED_MEMBER}</span>
    </Tooltip>
  );
}
